import { Contract, FormInput } from 'components/molecules';
import { useFormikContractHelpers } from 'hooks';
import { useTranslation } from 'react-i18next';
import { IContractInputWrapperProps } from '../../wrapper/ContractInputWrapper';

interface IContractInputAgreementDefaultShareProps
  extends Omit<IContractInputWrapperProps, 'name'> {
  id: string;
}

const ContractInputAgreementDefaultShare = ({
  id,
  ...props
}: IContractInputAgreementDefaultShareProps) => {
  const { setFieldValue, itemNameById, displayMode } =
    useFormikContractHelpers();

  const { t } = useTranslation();
  return (
    <Contract.Input.Wrapper {...props} id={id}>
      <FormInput.Select
        name={`${itemNameById(id)}.content.distributionTemplateShares.id`}
        placeholder={t('input.label.default-option')}
        className='contract-input-agreement contract-input-agreement-shares'
        value={{
          label: t('contract-template.digitalDistribution.default-share'),
          value: 0,
        }}
        displayMode
      />
      <FormInput.Number
        name={`${itemNameById(id)}.content.distributionTemplateShares.percent`}
        placeholder='0%'
        suffix='%'
        displayMode={displayMode}
        // helperText='Helper text example'
      />
    </Contract.Input.Wrapper>
  );
};

export default ContractInputAgreementDefaultShare;
